module.exports = __webpack_public_path__ + "media/images/mes_180_shop-2d17cda966f31f1afdc47d8145a10d61.png";